/**
 * Fixed sidebar copy of every Metal Market Intelligence article page (`./Blog.tsx`), passed in by
 * `src/pages/metal-resources/metal-market-intelligence/[slug].tsx`. The guide PDFs live on the
 * static assets host (`NEXT_PUBLIC_URI_STATIC`, owned by web-static-assets), one per language.
 */
import { StaticBlogContent } from "@components/Blog/Blog";
import { LanguageContent } from "@ryerson/frontend.common";

/** The article sidebar copy per language. `popularHeading` is English in all three. */
export const blogStaticeContent: LanguageContent<StaticBlogContent> = {
	en: {
		popularHeading: "Popular Content",
		ryersonGuideTitle: "Download Ryerson’s Guide to Buying Metal Online",
		ryersonGuideSubTitle: "Ready to buy metal online? We have every question answered.",
		ryersonGuideUrl: `${process.env.NEXT_PUBLIC_URI_STATIC}/static-assets/documents/pdfs/en/selection-guide/BuyingMetalOnline.pdf`,
	},
	fr: {
		popularHeading: "Popular Content",
		ryersonGuideTitle: "Télécharger le guide pour l’achat de métaux en ligne de Ryerson",
		ryersonGuideSubTitle:
			"Prêt à acheter du métal en ligne? Nous avons les réponses à toutes vos questions.",
		ryersonGuideUrl: `${process.env.NEXT_PUBLIC_URI_STATIC}/static-assets/documents/pdfs/fr/selection-guide/BuyingMetalOnline.pdf`,
	},
	es: {
		popularHeading: "Popular Content",
		ryersonGuideTitle: "Descargue la guía de Ryerson para comprar metales en línea",
		ryersonGuideSubTitle:
			"¿Listo para comprar metal en línea? Tenemos respuestas para todas las preguntas.",
		ryersonGuideUrl: `${process.env.NEXT_PUBLIC_URI_STATIC}/static-assets/documents/pdfs/es/selection-guide/BuyingMetalOnline.pdf`,
	},
};
